const carouselItems = [
  {
    id: 1,
    title: '国漫精品推荐：不可错过的十部神作',
    desc: '从《斗破苍穹》到《狐妖小红娘》，盘点国漫崛起之路上那些口碑与热度并存的经典作品，每一部都值得从头追到尾。',
    tag: '国漫推荐',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20manga%20art%20collection%2C%20powerful%20warriors%20and%20mystical%20creatures%20in%20ancient%20Chinese%20setting%2C%20warm%20coral%20and%20gold%20color%20palette%2C%20clean%20cream%20gradient%20background%2C%20cinematic%20composition%2C%20high%20detail%20illustration%2C%20editorial%20quality&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '日漫经典回顾：陪伴一代人成长的名作',
    desc: '从《海贼王》到《咒术回战》，重温那些陪伴我们成长的日漫经典，感受跨越时代的热血与感动。',
    tag: '日漫精选',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20classic%20collection%20illustration%2C%20nostalgic%20anime%20style%20with%20iconic%20character%20elements%2C%20warm%20amber%20and%20coral%20tones%2C%20clean%20cream%20background%2C%20cinematic%20composition%2C%20emotional%20atmosphere%2C%20high%20detail&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '韩漫热门精选：当下最流行的韩国漫画',
    desc: '韩漫凭借精致的画风和独特的叙事风格在全球掀起热潮，精选当下最火爆的韩漫作品，紧跟潮流不停歇。',
    tag: '韩漫热门',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%2C%20elegant%20modern%20characters%20in%20fashionable%20urban%20setting%2C%20soft%20romantic%20coral%20and%20cream%20tones%2C%20clean%20minimal%20background%2C%20cinematic%20composition%2C%20high%20detail%20editorial%20art&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '新作速览：近期上架的潜力新漫推荐',
    desc: '发现最新上架的优质漫画作品，从热血到治愈，编辑团队严选多部潜力新作，为您打开全新的漫画世界。',
    tag: '新作推荐',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20new%20manga%20release%20illustration%2C%20diverse%20colorful%20comic%20panels%20floating%20like%20a%20collage%2C%20warm%20coral%20and%20amber%20palette%2C%20clean%20cream%20background%2C%20modern%20editorial%20design%2C%20dynamic%20composition%2C%20high%20detail&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            编辑团队精心策划的漫画专题，带您深入探索漫画世界的精彩
          </p>
        </div>

        {/* All 4 items displayed at once, no sliding */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group rounded-2xl overflow-hidden bg-background-50 cursor-pointer transition-colors"
            >
              {/* Image */}
              <div className="relative aspect-[2/1] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              {/* Text */}
              <div className="p-5 md:p-6">
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
                <div className="mt-3 flex items-center gap-1 text-sm text-primary-600 font-medium">
                  <span className="whitespace-nowrap">查看专题</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}